const $getTranslate = function (lang, obj) {
  if (!lang || typeof obj === 'undefined') return ''
  return obj?.[lang] || 'Sin definir'
}
const getTranslate = {
  install: (app) => {
    app.config.globalProperties.$getTranslate = $getTranslate
    app.provide('getTranslate', $getTranslate)
  }
}
export default getTranslate
